import { Table, TableProps } from "antd";
import { useGetStatementTitleGroupRelatedNegotiationsQuery } from "../../../redux/api/reconciliationsApiSlice";
import { StatementTitleRelatedNegotiation } from "../../../types/reconciliation";
import React, { useMemo } from "react";
import dayjs from "dayjs";
import { euro, percentage } from "../../../utils/formatters";

export default function NegotiationEmittedTitlesTable({ uuid }: { uuid: string }) {

  const { data, isFetching, isUninitialized } = useGetStatementTitleGroupRelatedNegotiationsQuery({ uuid } ?? {});

  const loading = isUninitialized || isFetching;

  const columns: TableProps<StatementTitleRelatedNegotiation>["columns"] = useMemo(() => [
    {
      key: "state",
      dataIndex: "state",
      title: "Stato"
    },
    {
      key: "broker",
      dataIndex: "broker",
      title: "Broker"
    },
    {
      key: "policy_number",
      dataIndex: "policy_number",
      title: "Numero polizza"
    },
    {
      key: "lob",
      dataIndex: "lob",
      title: "Lob"
    },
    {
      key: "contractor",
      dataIndex: "contractor",
      title: "Contraente"
    },
    {
      title: "Decorrenza",
      dataIndex: "policy_effective_date",
      render: (value) => {
        return dayjs(value).format("DD-MM-YYYY");
      }
    },
    {
      key: "policy_expiring_date",
      title: "Scadenza",
      dataIndex: "policy_expiring_date",
      render: (value) => {
        return dayjs(value).format("DD-MM-YYYY");
      }
    },
    {
      key: "quoted_premium",
      title: "Premio (al 100%)",
      dataIndex: "quoted_premium",
      render: (value) => euro(value)
    },
    {
      key: "gross_premium",
      title: "Premio lordo",
      dataIndex: "gross_premium",
      render: (value) => euro(value)
    },
    {
      key: "fractional_gross_premium",
      title: "Premio lordo frazionato",
      dataIndex: "fractional_gross_premium",
      render: (value) => percentage(value)
    },
    {
      key: "fee_broker_perc",
      dataIndex: "fee_broker_perc",
      title: "Provvigioni broker",
      render: (value) => percentage(value)
    },
    {
      key: "delta_neg",
      title: "Delta",
      dataIndex: "delta_neg",
      render: (value) => percentage(value)
    }
  ], []);

  return <Table
    <StatementTitleRelatedNegotiation>
    columns={columns}
    loading={loading}
    dataSource={data}
    rowKey={"uuid"}
    scroll={{ x: true }}
    pagination={false}
  />;
}